module.exports = __webpack_public_path__ + "img/globe-nav-chevron-up-grey.6cfee961.svg";